// removed by extract-text-webpack-plugin
module.exports = {"container":"NUMbhprX1N4g8wyhr0nEg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsContainer/styles.css
// module id = 405
// module chunks = 0